<!-- Free Form Source Form -->
@if (freeFormSourceForm) {
  <medsurf-design-form-control-form
    [formGroup]="freeFormSourceForm"
    [class]="'w-full'"
    (onSubmit)="onSourceSubmit()">
    <div class="flex flex-column row-gap-2 align-items-center">
      <h4 class="uppercase align-self-start"
        translate="global.line">
      </h4>
      <!-- Height -->
      <medsurf-design-form-control-input-number [control]="freeFormSourceForm.controls.y"
        [class]="'w-full'"
        [min]="0"
        [label]="'global.line_start_y'"
        [showButtons]="false"
      (valueChange)="onSourceSubmit()"></medsurf-design-form-control-input-number>
      <!-- Width -->
      <medsurf-design-form-control-input-number [control]="freeFormSourceForm.controls.x"
        [class]="'w-full'"
        [min]="0"
        [label]="'global.line_start_x'"
        [showButtons]="false"
      (valueChange)="onSourceSubmit()"></medsurf-design-form-control-input-number>
    </div>
  </medsurf-design-form-control-form>
}

<!-- Free Form Style Form -->
@if (freeFormStyleForm) {
  <medsurf-design-form-control-form
    [formGroup]="freeFormStyleForm"
    [class]="'w-full'"
    (onSubmit)="onStyleSubmit()">
    <div class="flex flex-column row-gap-2 align-items-center">
      <!-- Height -->
      <medsurf-design-form-control-input-number [control]="freeFormStyleForm.controls.height"
        [class]="'w-full'"
        [min]="0"
        [label]="'global.line_vector_y'"
        [showButtons]="false"
      (valueChange)="onStyleSubmit()"></medsurf-design-form-control-input-number>
      <!-- Width -->
      <medsurf-design-form-control-input-number [control]="freeFormStyleForm.controls.width"
        [class]="'w-full'"
        [min]="0"
        [label]="'global.line_vector_x'"
        [showButtons]="false"
      (valueChange)="onStyleSubmit()"></medsurf-design-form-control-input-number>
    </div>
  </medsurf-design-form-control-form>
}